module.exports = __webpack_public_path__ + "img/CHART_AREA.524e1067.svg";